import $ from 'jquery'

class Project {

  constructor() {
    this.init()
  }


  init() {

    this.openinfo = $('.button--info')
    this.closeinfo = $('.button--closeinfo')
    this.close = $('.button--close')
    this.next = $('.button--projects')
    this.back = $('.button--back')
    this.body = $('body')

    this.projects =  $('.project')
    this.total = $('.project').length
    this.current = -1

    this.solution = $('.aside a')
    this.aside = $('.aside')

    this.addEvents()

  }

  addEvents() {

      this.openinfo.on('click', (e)=>{
        e.preventDefault();
        const el = $(e.currentTarget);
        el.addClass('is-hidden')
        this.body.addClass('has-info')
        const info = $('.is-current .info')
        info.addClass('is-visible')
      })

      this.closeinfo.on('click', (e)=>{
        e.preventDefault();
        this.openinfo.removeClass('is-hidden')
        const info = $('.is-current .info')
        this.body.removeClass('has-info')
        info.removeClass('is-visible')
      })

      this.close.on('click', (e)=>{
        e.preventDefault();

        const info = $('.is-current .info')
        info.removeClass('is-visible')
        $('.is-current').removeClass('is-current')
        $('.is-seen').removeClass('is-seen')
        this.body.removeClass('has-project')
        this.next.removeClass('disabled')
        this.current = -1
      })

      this.next.on('click', (e)=>{
        e.preventDefault();

      //  console.log(this.current, this.total, 'before')



        if( this.current < (this.total -1)){
          ++this.current
          $('.is-current').addClass('is-seen').removeClass('is-current')
          const project = $('.project').eq(this.current)
          project.addClass('is-current')
          this.body.addClass('has-project')

          // if (this.current == this.total ) {
          //   this.next.addClass('disabled')
          // }

          const info = $('.is-seen .info')
          this.openinfo.removeClass('is-hidden')
          info.removeClass('is-visible')
        }

         else {
        //   const info = $('.is-current .info')
        //   info.removeClass('is-visible')
        //   $('.is-current').removeClass('is-current')
        //   $('.is-seen').removeClass('is-seen')
        //   this.body.removeClass('has-project')
        //   this.next.removeClass('disabled')
          this.current = this.total - 1
         }

         this.back.toggleClass('disabled', this.current == 0)
         this.next.toggleClass('disabled', this.current == this.total - 1)

      //  console.log(this.current, this.total);

      })

      this.back.on('click', (e)=>{
        e.preventDefault();


        if( this.current > 0 ){
          --this.current
          $('.is-current').removeClass('is-current')
          const project = $('.project').eq(this.current)
          project.addClass('is-current').removeClass('is-seen')
          this.body.addClass('has-project')

          // if (this.current == this.total ) {
          //   this.next.addClass('disabled')
          // }

          const info = $('.is-seen .info')
          this.openinfo.removeClass('is-hidden')
          info.removeClass('is-visible')


        }

        else {

        }

        this.back.toggleClass('disabled', this.current == 0)
        this.next.toggleClass('disabled', this.current == this.total - 1)

      //  console.log(this.current);

      })


      this.solution.on('mouseenter', (e)=>{
        this.aside.addClass('has-solution')
        $(e.currentTarget).addClass('is-active')

      })
      this.solution.on('mouseleave', (e)=>{
        this.aside.removeClass('has-solution')
        $(e.currentTarget).removeClass('is-active')
      })

  }

  destroy(){
    this.openinfo.off('click')
    this.closeinfo.off('click')
    this.close.off('click')
    this.next.off('click')
    this.body.removeClass('has-info')
    this.body.removeClass('has-project')

    this.solution.off('mouseenter')
    this.solution.off('mouseleave')
  }

}

module.exports = Project
